<span class="cursor-pointer" (click)="executeAction('rowAction')">{{value}}</span>
